import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getMultiCouponDescription } from './utils';
import { getMultiCouponDialogContentStyles } from '../styles/multi-coupon-dialog-content-styles';
import { DefaultCurrencyCode } from '../helpers';
import { MultiCouponDetailsProps } from '../coupon-props';

export const MultiCouponClaimedDialogContent = (props) => {
  const {
    coupon,
    getCouponCurrencyCode,
  } = props;

  const classes = useDefaultStyles(getMultiCouponDialogContentStyles);
  const i18n = useContext(I18nContext);

  if (!coupon || !coupon.couponDetails) {
    return null;
  }

  const currency = getCouponCurrencyCode(coupon.couponDetails.CurrencyId) || DefaultCurrencyCode;

  return (
    <div className={classNames(classes.couponContainer, classes.confirmDialogOverride, 'multi-coupon-claimed-container')}>
      <div className={classNames(classes.couponWarningDetails, 'multi-coupon-claimed-warning-details')}>
        {i18n.getString(_TL_('Once you complete the sign-up process, we\'ll apply this coupon to your account.'))}
      </div>
      <div className={classNames(classes.optionText, 'coupon-choice-text')}>
        <span className={classNames(classes.optionTypeText, 'coupon-choice-type')}>
          {i18n.getString(_TL_('Claimed coupon:'))}
        </span>
        <span className="coupon-choice-details">
          {getMultiCouponDescription(i18n, coupon.couponDetails, currency)}
        </span>
      </div>
    </div>
  );
};

MultiCouponClaimedDialogContent.propTypes = {
  coupon: MultiCouponDetailsProps,
  getCouponCurrencyCode: PropTypes.func,
};

MultiCouponClaimedDialogContent.defaultProps = {
  coupon: null,
  getCouponCurrencyCode: _.noop,
};
